if (!customElements.get('pickup-availability')) {
  customElements.define(
    'pickup-availability',
    class PickupAvailability extends HTMLElement {
      constructor() {
        super();

        if (!this.hasAttribute('available')) return;

        this.errorHtml = this.querySelector('template').content.firstElementChild.cloneNode(true);
        this.onClickRefreshList = this.onClickRefreshList.bind(this);
        this.fetchAvailability(this.dataset.variantId);
      }

      fetchAvailability(variantId) {
        let rootUrl = this.dataset.rootUrl;
        if (!rootUrl.endsWith('/')) {
          rootUrl = rootUrl + '/';
        }
        const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup-availability`;

        fetch(variantSectionUrl)
          .then((response) => response.text())
          .then((text) => {
            const sectionInnerHTML = new DOMParser()
              .parseFromString(text, 'text/html')
              .querySelector('.shopify-section');
            this.renderPreview(sectionInnerHTML);
          })
          .catch((e) => {
            const button = this.querySelector('button');
            if (button) button.removeEventListener('click', this.onClickRefreshList);
            this.renderError();
          });
      }

      onClickRefreshList(evt) {
        this.fetchAvailability(this.dataset.variantId);
      }

      renderError() {
        this.innerHTML = '';
        this.appendChild(this.errorHtml);

        this.querySelector('button').addEventListener('click', this.onClickRefreshList);
      }

renderPreview(sectionInnerHTML) {
  // Remove any existing drawer instance
  const existingDrawer = document.querySelector('pickup-availability-drawer');
  document.body.appendChild(sectionInnerHTML.querySelector('pickup-availability-drawer'));
  // --- Replace ONLY the pickup time text inside drawer's <p class="pickup-availability-preview caption-large"> ---
(function replaceDrawerPickupTime() {
  const pickupNote = (this.dataset && this.dataset.pickupNote) ? this.dataset.pickupNote.trim() : '';
  if (!pickupNote) return;

  const drawer = document.querySelector('pickup-availability-drawer');
  if (!drawer) return;

  // find the paragraph
  const p = drawer.querySelector('p.pickup-availability-preview.caption-large') || drawer.querySelector('.pickup-availability-preview.caption-large');
  if (!p) return;

  // Build the concatenated text of childNodes to find the last comma position
  const nodes = Array.from(p.childNodes); // includes elements, text nodes
  let commaGlobalIndex = -1;
  let cumulative = 0;

  for (let i = 0; i < nodes.length; i++) {
    const n = nodes[i];
    const txt = n.textContent || '';
    const idxInNode = txt.lastIndexOf(',');
    if (idxInNode !== -1) {
      commaGlobalIndex = cumulative + idxInNode;
    }
    cumulative += txt.length;
  }

  if (commaGlobalIndex !== -1) {
    // found a comma — replace everything after that comma
    let running = 0;
    for (let i = 0; i < nodes.length; i++) {
      const n = nodes[i];
      const txt = n.textContent || '';
      const nextRunning = running + txt.length;
      if (commaGlobalIndex < nextRunning) {
        const idxInNode = commaGlobalIndex - running;
        if (n.nodeType === Node.TEXT_NODE) {
          // preserve up to comma + following spaces
          const afterComma = txt.slice(idxInNode + 1);
          const m = afterComma.match(/^(\s*)/);
          const spaces = m ? m[0] : '';
          n.textContent = txt.slice(0, idxInNode + 1) + spaces;
          // remove all following sibling nodes
          let toRemove = n.nextSibling;
          while (toRemove) {
            const rem = toRemove;
            toRemove = toRemove.nextSibling;
            rem.parentNode.removeChild(rem);
          }
          // append pickupNote as plain text (preserve no HTML)
          const insertText = (spaces ? '' : ' ') + pickupNote;
          n.parentNode.appendChild(document.createTextNode(insertText));
        } else {
          // comma inside an element — fallback: remove following siblings and append pickupNote
          let toRemove = n.nextSibling;
          while (toRemove) {
            const rem = toRemove;
            toRemove = toRemove.nextSibling;
            rem.parentNode.removeChild(rem);
          }
          n.parentNode.appendChild(document.createTextNode(' ' + pickupNote));
        }
        return;
      }
      running = nextRunning;
    }
  } else {
    // No comma found — fallback: replace last non-empty text node only
    for (let i = nodes.length - 1; i >= 0; i--) {
      const n = nodes[i];
      if (n.nodeType === Node.TEXT_NODE && n.textContent.trim() !== '') {
        n.textContent = ' ' + pickupNote;
        return;
      }
    }
    // If no text node found, append a span.caption
    const span = document.createElement('span');
    span.className = 'caption';
    span.textContent = pickupNote;
    p.appendChild(span);
  }
}).call(this);

  if (existingDrawer) existingDrawer.remove();

  // If no preview returned, clear and exit
  const previewEl = sectionInnerHTML.querySelector('pickup-availability-preview');
  if (!previewEl) {
    this.innerHTML = '';
    this.removeAttribute('available');
    return;
  }

  // Render preview HTML inside the element (product page preview)
  this.innerHTML = previewEl.outerHTML;
  this.setAttribute('available', '');

  // Read metafield value passed from product template
  const pickupNote = this.dataset.pickupNote; // comes from data-pickup-note attribute

  // Replace content of .caption on product page (if exists)
  if (pickupNote && pickupNote.trim() !== '') {
    const captionEl = this.querySelector('.caption');
    if (captionEl) {
      captionEl.textContent = pickupNote;
    }
  }

  // Prepare drawer element (from fetched section HTML)
  const drawerEl = sectionInnerHTML.querySelector('pickup-availability-drawer');

  // If drawer exists, inject/replace the .caption-large inside it
  if (drawerEl) {
// ✅ Replace only the inner text inside drawer .caption (safe, no HTML changes)
const pickupNote = this.dataset.pickupNote;
if (pickupNote && pickupNote.trim() !== '') {
  const drawer = document.querySelector('pickup-availability-drawer');
  if (drawer) {
    const captionSpan = drawer.querySelector('.caption-large .caption');
    if (captionSpan) {
      captionSpan.textContent = pickupNote;
    }
  }
}


    // Append drawer to body
    document.body.appendChild(drawerEl);

    // Apply color classes from product page (if any)
    const productColorScheme = this.dataset.productPageColorScheme || '';
    const colorClassesToApply = productColorScheme.split(' ').filter(Boolean);
    const appendedDrawer = document.querySelector('pickup-availability-drawer');
    if (appendedDrawer) {
      colorClassesToApply.forEach((colorClass) => appendedDrawer.classList.add(colorClass));
    }
  }

  // Re-attach open drawer button handler
  const button = this.querySelector('button');
  if (button) {
    button.addEventListener('click', (evt) => {
      const drawer = document.querySelector('pickup-availability-drawer');
      if (drawer && typeof drawer.show === 'function') {
        drawer.show(evt.target);
      }
    });
  }
}


    }
  );
}

if (!customElements.get('pickup-availability-drawer')) {
  customElements.define(
    'pickup-availability-drawer',
    class PickupAvailabilityDrawer extends HTMLElement {
      constructor() {
        super();

        this.onBodyClick = this.handleBodyClick.bind(this);

        this.querySelector('button').addEventListener('click', () => {
          this.hide();
        });

        this.addEventListener('keyup', (event) => {
          if (event.code.toUpperCase() === 'ESCAPE') this.hide();
        });
      }

      handleBodyClick(evt) {
        const target = evt.target;
        if (
          target != this &&
          !target.closest('pickup-availability-drawer') &&
          target.id != 'ShowPickupAvailabilityDrawer'
        ) {
          this.hide();
        }
      }

      hide() {
        this.removeAttribute('open');
        document.body.removeEventListener('click', this.onBodyClick);
        document.body.classList.remove('overflow-hidden');
        removeTrapFocus(this.focusElement);
      }

      show(focusElement) {
        this.focusElement = focusElement;
        this.setAttribute('open', '');
        document.body.addEventListener('click', this.onBodyClick);
        document.body.classList.add('overflow-hidden');
        trapFocus(this);
      }
    }
  );
}
